// extracted by mini-css-extract-plugin
module.exports = {"button":"AbandonedBookingsAddButton_button__2Eg6o","dropdown":"AbandonedBookingsAddButton_dropdown__3nlAN","dropdownContent":"AbandonedBookingsAddButton_dropdownContent__11WDZ"};